var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-2"},[_c('a',{staticClass:"btn",attrs:{"href":"/settings/terminal"}},[_vm._v(_vm._s(_vm.$t('terminals.menuName')))])])}
var staticRenderFns = []

export { render, staticRenderFns }